module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (115).e481abca.jpg";